import React from 'react';
import FiltersDescUI from 'components/DataFiltering/FiltersDescUI';

interface IEntitiesProps {
    entFilters: any;
    setEntFilters: any;
    comFilters: any;
    setComFilters: any;
    cur_user: any;
    entityState: any;
    setEntityState: any;
    commodityState: any;
    setCommodityState: any;
  }

const ParamsStep: React.FC<IEntitiesProps> = ({ entityState, setEntityState, cur_user, entFilters, setEntFilters, commodityState, setCommodityState }) => {
  return(
    <>
      <div className='bill-container-fit-screen-content'>
        <FiltersDescUI
          commodityState={commodityState}
          setCommodityState={setCommodityState}
          userHasEntitySearch={true}
          filters={entFilters}
          setFilters={setEntFilters}
          entityState={entityState}
          setEntityState={setEntityState}
          cur_user={cur_user}
        />
      </div>
    </>
  );
};
export default ParamsStep;
